// extracted by mini-css-extract-plugin
export default {"page":"N1-z","cartModal":"O1-z","checkout":"P1-z","placeholder":"Q1-z","account":"R1-z"};